import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export const ProtectedRoute = ({ children, role }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-loading">
                <div className="un-label text-un-grape">Loading…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    if (role && user.role !== role) {
        return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
    }
    return children;
};
